import React from 'react';
import Header from '../Header';
import StatusBar from '../StatusBar';
import Notification from '../Notification';
import { useLocation, Navigate } from 'react-router-dom';
import useTheme from '../../hooks/useTheme';
import routes from '../../utils/routes';
import { isAuthenticated } from '../../utils/auth';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { theme } = useTheme();
  
  // Check if user is authenticated
  if (!isAuthenticated()) {
    // If not authenticated, redirect to login
    return <Navigate to={routes.public.LOGIN} replace />;
  }
  
  // List of auth routes where we don't want to show the header
  const authRoutes = [
    routes.public.LOGIN,
    routes.public.REGISTER,
    routes.public.FORGOT_PASSWORD,
    routes.public.RESET_PASSWORD,
    routes.public.VERIFY_OTP
  ];
  
  // Check if the current route is an auth route
  const isAuthRoute = authRoutes.includes(currentPath);
  
  return (
    <div className={`layout ${theme}`}>
      {!isAuthRoute && <Header />}
      <div className={`layout-content ${!isAuthRoute ? 'with-header' : ''}`}>
        {children}
      </div>
      {/* Render StatusBar outside of layout-content */}
      {!isAuthRoute && <StatusBar />}
      
      {/* Notification component will always be rendered regardless of route */}
      <Notification />
    </div>
  );
};

export default Layout; 